import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import EmailModal from "./EmailModal";
import useLogEvent from "~/hooks/useLogEvent";

interface RegisterYourEmailModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function RegisterYourEmailModal({
  isOpen,
  onClose,
}: RegisterYourEmailModalProps) {
  const {
    isOpen: isEmailModelOpen,
    onOpen: onEmailModelOpen,
    onClose: onEmailModelClose,
  } = useDisclosure();

  const logEvent = useLogEvent();

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
        <ModalOverlay />
        <ModalContent
          borderStyle={"solid"}
          borderWidth={"4px"}
          borderRadius={"1rem"}
          borderColor={"gray.200"}
          padding={4}
          width={"540px"}
          maxWidth={"90vw"}
          backgroundColor={useColorModeValue("gray.200", "gray.800")}
        >
          <ModalHeader textAlign={"center"} fontWeight={500} fontSize="2xl">
            Email missing!
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text
              color={useColorModeValue("gray.800", "gray.300")}
              fontSize={"sm"}
            >
              Register your email to learn the result of giveaways and upcoming
              campaigns!
            </Text>
          </ModalBody>

          <ModalFooter>
            <Flex width={"100%"}>
              <Button
                colorScheme={"discord"}
                color={"gray.200"}
                flex={1}
                onClick={() => {
                  onClose();
                  onEmailModelOpen();
                  logEvent("register_email_clicked");
                }}
              >
                Register Email
              </Button>
            </Flex>
          </ModalFooter>

          <ModalCloseButton />
        </ModalContent>
      </Modal>
      <EmailModal
        isOpen={isEmailModelOpen}
        onClose={onEmailModelClose}
        mode="add"
      />
    </>
  );
}
